import JsBarcode from 'jsbarcode';

/**
 * Options forwarded to JsBarcode. Only the subset the label printers use;
 * everything else keeps JsBarcode's defaults.
 */
export interface BarcodeSvgOptions {
  format?: string;
  width?: number;
  height?: number;
  displayValue?: boolean;
  fontSize?: number;
  margin?: number;
  marginLeft?: number;
  marginRight?: number;
}

/**
 * PRX-39: render a barcode to inline SVG markup from the BUNDLED jsbarcode.
 *
 * The delivery and vial label popups used to load JsBarcode from a CDN at
 * print time and, when the script did not arrive before the print fired
 * (offline pharmacy PC, blocked CDN, slow link, popup racing the load), they
 * silently printed the label WITHOUT its barcode — PharmAssist's first
 * delivery labels came out with no scannable Rx number. Rendering here, in
 * the app, removes the network dependency and the race: the markup is
 * already in the HTML the popup receives.
 *
 * Returns '' when the value is empty or rendering fails, after logging why —
 * the label still prints (an unscannable label beats no label), and the
 * console line names the cause instead of leaving a silent gap.
 */
export function renderBarcodeSvg(value: string | null | undefined, options: BarcodeSvgOptions = {}): string {
  const text = (value ?? '').toString().trim();
  if (!text) {
    console.error('[barcode] No value to encode — label prints without a barcode');
    return '';
  }
  try {
    const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    JsBarcode(svg, text, { format: 'CODE128', ...options });
    return svg.outerHTML;
  } catch (error) {
    console.error('[barcode] Rendering failed — label prints without a barcode', { value: text, error });
    return '';
  }
}
